import React, { useEffect } from 'react';
import "../App.css";
import { Icon } from './Icon';

// ─── TOAST NOTIFICATION ───────────────────────────────────────────────
export function Toast({ msg, type, onDone }) {
  useEffect(() => { const t = setTimeout(onDone, 3500); return () => clearTimeout(t); }, []);
  const C = {
    success: { bg: "#F0FDF4", border: "#BBF7D0", color: "#15803D", icon: "success" },
    error:   { bg: "#FFF1F2", border: "#FECACA", color: "#BE123C", icon: "cancel" },
    info:    { bg: "#EFF6FF", border: "#BFDBFE", color: "#1D4ED8", icon: "info" },
    warning: { bg: "#FFFBEB", border: "#FDE68A", color: "#B45309", icon: "warning" }
  };
  const c = C[type] || C.info;
  return (
    <div className="toast" style={{ background: c.bg, border: `1px solid ${c.border}`, color: c.color, display: "flex", alignItems: "center", gap: 8 }}>
      <Icon name={c.icon} size={18} />{msg}
    </div>
  );
}
